<template>
  <div id="wizardCard" class="card card-wizard">
    <div class="vue-form-wizard md">
      <div class="content">
        <div class="container">
          <div class="row">
            <legend>Usuarios del sistema </legend>
          </div>
          <div v-if="add_item">
            <div class="row">
              <div class="form-group col-md-4">
                <label class="control-label">Nombre(s)</label>
                <input class="form-control" type="text" name="Nombre" v-validate="item_usuariosValidations.Nombre" v-model="item_usuarios.Nombre" placeholder="Nombre(s)"><small class="text-danger" v-show="Nombre.invalid">
                  {{ getError('Nombre') }}
                </small>
              </div>
              <div class="form-group col-md-4">
                <label class="control-label">Apellido Paterno</label>
                <input class="form-control" type="text" name="Paterno" v-validate="item_usuariosValidations.Paterno" v-model="item_usuarios.Paterno" placeholder="Apellido Paterno">
                <small class="text-danger" v-show="Paterno.invalid">
                  {{ getError('Paterno') }}
                </small>
              </div>
              <div class="form-group col-md-4">
                <label class="control-label">Apellido Materno</label>
                <input class="form-control" type="text" name="Materno" v-validate="item_usuariosValidations.Materno" v-model="item_usuarios.Materno" placeholder="Apellido Materno">
              </div>
              <div class="form-group col-md-4">
                <label class="control-label">Correo</label>
                <input class="form-control" type="text" name="User" v-validate="item_usuariosValidations.User" v-model="item_usuarios.User" placeholder="test@email.com"><small class="text-danger" v-show="User.invalid">
                  {{ getError('User') }}
                </small>
              </div>
              <div class="form-group col-md-4" v-if="edit_item == null">
                <label class="control-label">Contraseña</label>
                <input class="form-control" type="password" name="Password" ref="Password" v-validate="item_usuariosValidations.Password" :key="'contraseña'" v-model="item_usuarios.Password" placeholder="*****"><small class="text-danger" v-show="Password.invalid">
                  {{ getError('Password') }}
                </small>
              </div>
              <div class="form-group col-md-4" v-if="edit_item == null">
                <label class="control-label">Confirmar contraseña</label>
                <input class="form-control" type="password" name="Confirmar" v-validate="'required|confirmed:Password'" v-model="item_usuarios.Confirmar" :key="'confirmacion'" placeholder="*****"><small class="text-danger" v-show="Confirmar.invalid">
                  {{ getError('Confirmar') }}
                </small>
              </div>
              <div class="form-group col-md-6">
                <label class="control-label">Tipo de Usuario</label>
                <el-select clearable filterable class="select-default" placeholder="Seleccione una opción" name="tipo_id" v-validate="item_usuariosValidations.tipo_id" v-model="item_usuarios.tipo_id">
                  <el-option v-for="option in tipos" class="select-default" :value="option.id" :label="option.valor" :key="option.label"></el-option>
                </el-select><small class="text-danger" v-show="tipo_id.invalid">
                  {{ getError('tipo_id') }}
                </small>
              </div>
              <div class="form-group col-md-6">
                <label class="control-label">Dependencia</label>
                <el-select clearable filterable class="select-default" placeholder="Seleccione una opción" v-model="item_usuarios.ID_Dependencia" name="ID_Dependencia" v-validate="item_usuariosValidations.ID_Dependencia" >
                  <el-option v-for="option in dependencias" class="select-default" :value="option.id" :label="option.valor" :key="option.label"></el-option>
                </el-select>
                <small class="text-danger" v-show="ID_Dependencia.invalid">
                  {{ getError('ID_Dependencia') }}
                </small>
              </div>
            </div>
            <div class="row" v-if="edit_item != null">
              <legend> Modificar Contraseña</legend>
              <div class="form-group col-md-12">
                <label class="control-label"> Modificar constraseña: </label>
                <br>
                <div>
                  <p-radio name="modificar" v-model="item_usuarios.modificar" :inline=true label="0">Sí</p-radio>
                  <p-radio name="modificar" v-model="item_usuarios.modificar" :inline=true label="1">No</p-radio>
                </div>
              </div>
              <div class="form-group col-md-4" v-if="item_usuarios.modificar == '0'">
                <label class="control-label">Contraseña</label>
                <input class="form-control" type="password" name="Password" ref="Password" v-validate="item_usuariosValidations.Password" v-model="item_usuarios.Password" :key="'contraseña2'" placeholder="*****"><small class="text-danger" v-show="Password.invalid">
                  {{ getError('Password') }}
                </small>
              </div>
              <div class="form-group col-md-4" v-if="item_usuarios.modificar == '0'">
                <label class="control-label">Confirmar contraseña</label>
                <input class="form-control" type="password" name="Confirmar" v-validate="'required|confirmed:Password'" v-model="item_usuarios.Confirmar" :key="'confirmacion2'" placeholder="*****"><small class="text-danger" v-show="Confirmar.invalid">
                  {{ getError('Confirmar') }}
                </small>
              </div>
            </div>
            <div class="row justify-content-end m-3">
              <button class="btn btn-primary" @click.prevent="addItem()">
                <span v-if="edit_item == null">
                  <i class="fa fa-plus"></i> Agregar </span>
                <span v-else>
                  <i class="fa fa-save"></i> Guardar </span>
              </button>
              <button class="btn btn-danger ml-3" @click.prevent="cancelEdit()">
                <span>
                  <i class="fa fa-times"></i> Cancelar </span>
              </button>
            </div>
            <div class="row">
              <hr class="col-md-12 bg-info">
            </div>
          </div>
          <div v-if="!add_item">
            <div class="row">
              <div class="col-md-6">
                <button class="btn btn-primary" @click.prevent="showItem()">
                  <span>
                    <i class="fa fa-plus"></i> Agregar </span>
                </button>
              </div>
              <div class="col-sm-6 col-md-6 col-lg-6 pull-right">
                <b-form-group>
                  <b-input-group>
                    <b-form-input type="search" v-model="filter" placeholder="Buscar"></b-form-input>
                  </b-input-group>
                </b-form-group>
              </div>
            </div>
            <div class="row mt-3 mb-4">
              <div class="col-sm-12 col-md-12 col-lg-12">
                <v-data-table :headers="headers" :items="list_usuarios" :items-per-page="5" class="" :search="filter" :fixed-header="true" :custom-filter="buscaPers">
                  <template v-slot:item.acciones="{ item }">
                    <div class="d-flex justify-content-center">
                      <b-button @click.prevent="editItem(item)" class="btn-s edit mr-2" variant="success" :disabled="edit_item != null">
                        <i class="fas fa-pencil-alt"></i></b-button>
                      <br>
                      <b-button @click.prevent="removeItem(item)" class="btn-s delete" variant="danger" :disabled="edit_item != null">
                        <i class="fas fa-times"></i></b-button>
                    </div>
                  </template>

                  <template v-slot:item.ID_Dependencia="{ item }">
                    <div>{{ getDependenciasFilter(item.ID_Dependencia) }}</div>
                    <!-- <div>{{getDependenciasFilter(row.item.ID_Dependencia)}}</div> -->
                  </template>
                  <template v-slot:item.Nombre="{ item }">
                    <div>{{ item.Nombre + ' ' + item.Paterno + ' ' + item.Materno }}</div>
                    <!-- <div>{{getDependenciasFilter(row.item.ID_Dependencia)}}</div> -->
                  </template>
                  <template v-slot:item.tipo_id="{ item }">
                    <div>{{ getTipoUsuarios(item.tipo_id) }}</div>
                  </template>
                </v-data-table>
              </div>
            </div>
            <!-- <div class="row mt-3 mb-4">
              <div class="col-sm-12 col-md-12 col-lg-12">
                <b-table id="tbl_usuarios" responsive hover :items="filtro_usuarios" :fields="fields_list" :per-page="perPage" :current-page="currentPage" show-empty :filter="filter" @filtered="onFiltered">
                  <template v-slot:cell(acciones)="row" class="actions">
                    <b-button size="sm" @click.prevent="editItem(row)" class="edit mr-2" variant="success" :disabled="edit_item != null">
                      <i class="ti-pencil"></i></b-button>
                    <br>
                    <b-button size="sm" @click.prevent="removeItem(row)" class="delete mr-2" variant="danger" :disabled="edit_item != null">
                      <i class="ti-close"></i></b-button>
                  </template>
                  <template slot="empty">
                    <h5>No existen registros</h5>
                  </template>
                  <template slot="tipo_id" slot-scope="row">
                    {{getTipoUsuarios(row.item.tipo_id)}}</template>
                  <template slot="ID_Dependencia" slot-scope="row">
                    {{getDependenciasFilter(row.item.ID_Dependencia)}}</template>
                </b-table>
              </div>
              <div class="col-mb-8 col-8">
                <b-col md="6" class="my-1">
                  <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" first-text="<<" prev-text="<" next-text=">" last-text=">>" aria-controls="tbl_usuarios"></b-pagination>
                </b-col>
              </div>
              <div class="col-mb-12 col-12">
                <p class="category">Mostrando <b>{{from + 1}}</b> a <b>{{to}}</b> de <b>{{total}}</b> registros</p>
              </div>

            </div>
           -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import {
  Select,
  Option
} from 'element-ui'
import {
  mapFields
} from 'vee-validate'
import PPagination from 'src/components/UIComponents/Pagination.vue'
Vue.use(Select)
Vue.use(Option)
export default {
  components: {
    PPagination
  },
  props: ['data'],
  data () {
    return {
      id: 1,
      add_item: false,
      edit_item: null,
      tipos: null,
      // filtro_usuarios: [],
      perPage: 10,
      rows: null,
      currentPage: 1,
      filter: null,
      // dependencias: null,
      item_usuarios: {
        id: 0
      },
      list_usuarios: [],
      item_usuariosValidations: {
        Nombre: {
          required: true
        },
        Paterno: {
          required: true
        },
        User: {
          required: true
        },
        Password: {
          required: true
        },
        tipo_id: {
          required: true
        },
        ID_Dependencia: {
          required: true
        },
        Confirmar: {}
      },
      /* fields_list: [{
        key: "acciones",
        label: "Acciones",
        tdClass: "ancho text-center",
        thClass: 'ancho'
      }, {
        key: "Nombre",
        label: "Nombre completo",
        tdClass: "text-left",
        formatter: "emptyFields"
      }, {
        key: "User",
        label: "Usuario",
        tdClass: "text-left",
        formatter: "emptyFields"
      }, {
        key: "ID_Dependencia",
        label: "Dependencia",
        tdClass: "text-left",
        formatter: "emptyFields"
      }, {
        key: "tipo_id",
        label: "Tipo",
        tdClass: "text-left",
        formatter: "emptyFields"
      }], */
      headers: [{
        text: 'Acciones',
        align: 'center',
        sortable: false,
        value: 'acciones',
        class: ''
      }, {
        text: 'Nombre completo',
        value: 'Nombre',
        align: 'center'
      }, {
        text: 'Usuario',
        value: 'User',
        align: 'center'
      }, {
        text: 'Dependencia',
        value: 'ID_Dependencia',
        align: 'center'
      }, {
        text: 'Tipo',
        value: 'tipo_id',
        align: 'center'
      }]
    }
  },
  computed: {
    ...mapFields(['Nombre', 'Paterno', 'User', 'Password', 'tipo_id', 'ID_Dependencia', 'Confirmar']),
    to () {
      let highBound = this.from + this.perPage
      if (this.total < highBound) {
        highBound = this.total
      }
      return highBound
    },
    from () {
      return this.perPage * (this.currentPage - 1)
    },
    total () {
      // console.log(this.list_usuarios.length);
      this.rows = this.list_usuarios.length
      return this.list_usuarios.length
    }
  },
  watch: {
    '$route': 'checkPermissions'
  },
  methods: {
    /* onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.rows = filteredItems.length
      this.currentPage = 1
    }, */
    checkPermissions () {
      let permiso = [8]
      if (!this.getKey('permisos').some(r => permiso.includes(r))) {
        localStorage.clear()
        this.$router.push('/login')
        this.$router.go()
      }
    },
    initItem () {
      this.item_usuarios = {
        acciones: '',
        Nombre: '',
        Paterno: '',
        User: '',
        Password: '',
        Confirmar: '',
        modificar: '0',
        ID_Dependencia: 29,
        id: 0
      }
    },
    showItem () {
      this.add_item = !this.add_item
      if (this.add_item) {
        this.$validator.resume()
      } else {
        this.$validator.pause()
      }
    },
    cancelEdit () {
      if (this.edit_item) {
        this.edit_item._rowVariant = ''
        // this.edit_item.item._rowVariant = "";
      }
      this.initItem()
      this.showItem()
      this.edit_item = null
    },
    addItem () {
      this.$validator.validateAll().then(response => {
        if (response) {
          if (this.item_usuarios) {
            this.loadButton(this.$refs.btnSave)
            // this.item_usuarios.Nombre = this.item_usuarios.nom;
            this.$http.post('usuarios', this.item_usuarios).then(response => {
              if (response.data.usuario) {
                this.StepOk('Guardado')
                // this.item_usuarios.Nombre = this.item_usuarios.Nombre + ' ' + this.item_usuarios.Paterno || '' + ' ' + this.item_usuarios.Materno || ''
                if (this.edit_item === undefined || this.edit_item === null) {
                  this.list_usuarios.push({
                    ...response.data.usuario
                  })
                } else {
                  let index = this.list_usuarios.map(u => {
                    return u.id
                  }).indexOf(response.data.usuario.id)
                  this.list_usuarios.splice(index, 1, response.data.usuario)
                  // this.list_usuarios.splice(this.edit_item.index, 1, this.item_usuarios);
                  this.edit_item._rowVariant = ''
                  // this.edit_item.item._rowVariant = "";
                }
                this.initItem()
                this.showItem()
                this.edit_item = null
              } else {
                this.StepW('El correo ya se encuentra dado de alta')
              }
            }, error => {
              this.StepError(error)
            })
          }
        } else {
          this.StepW('Hay campos sin completar')
        }
      })
    },
    editItem (indice) {
      this.showItem()
      this.edit_item = indice
      // console.log(this.edit_item.item);
      this.item_usuarios = {
        ...this.edit_item
      }
      this.edit_item._rowVariant = 'danger'
      $('.main-panel').animate({
        scrollTop: 100
      }, 500, 'swing')
    },
    removeItem (item) {
      if (item.id !== null) {
        this.Ask('Desea borrar este registro', () => {
          this.$http.delete('usuarios/' + item.id).then(response => {
            let index = this.list_usuarios.map(u => {
              return u.id
            }).indexOf(item.id)
            this.list_usuarios.splice(index, 1)
            this.StepOk('Usuario Eliminado')
          }, error => {
            this.Err(error)
          })
        })
      }
    },
    getError (fieldName) {
      return this.errors.first(fieldName)
    },
    getTipoUsuarios (index) {
      var resp = ' '
      if (this.tipos) {
        this.tipos.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor
            return resp
          }
        })
      }
      return resp
    },
    getDependenciasFilter (index) {
      var resp = ' '
      if (this.dependencias) {
        this.dependencias.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor
            return resp
          }
        })
      }
      return resp
    },
    buscaPers (value, search, item) {
      if (typeof value === 'string') {
        let nombre = ((item.Nombre || '') + ' ' + (item.Paterno || '') + ' ' + (item.Materno || '')).toLowerCase()
        let user = (item.User || '').toLowerCase()
        return nombre.indexOf(search) !== -1 || user.indexOf(search) !== -1
      }
      return false
    }
  },
  created () {
    this.checkPermissions()
    this.initItem()
    this.$http.get('usuarios').then(response => {
      this.list_usuarios = response.data.usuarios
      // this.filtro_usuarios = this.list_usuarios;
    }, error => {
      this.Err(error)
    })
    this.$http.get('getTipoUsuarios').then(response => {
      this.tipos = response.data.tipos
    }, error => {
      this.Err(error)
    })
    // this.$http.get("cat_ente_publico").then(response => {
    //   this.dependencias = response.data.entes_publicos;
    // }, error => {
    //   this.Err(error);
    // });
  },
  mounted () {
    this.checkCatalogs()
  }
}

</script>
<style>
.ancho {
  width: 80px !important;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/Usuarios.vue